/* NDW v2 header behaviour.
   Moved out of an inline <script> into this external asset because the Shopify
   dev server (and section-rendering) can fail to execute inline section scripts
   to completion. External assets load reliably. Liquid-derived values are read
   from data-* attributes on #siteNav. */
(function () {
  function getNav() { return document.getElementById('siteNav'); }

  /* ---- Mobile hamburger via event delegation on document ----
     Robust to render timing: the document always exists and the burger is
     resolved at click-time, so it works regardless of when this runs. */
  function ndwSetNav(open) {
    var nav = getNav();
    if (!nav) return;
    var burger = document.querySelector('.site-nav__burger');
    nav.classList.toggle('is-nav-open', open);
    document.documentElement.classList.toggle('is-nav-locked', open);
    document.body.classList.toggle('is-nav-locked', open);
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var nav = getNav();
    if (t.closest && t.closest('.site-nav__burger')) {
      ndwSetNav(!(nav && nav.classList.contains('is-nav-open')));
      return;
    }
    if (nav && nav.classList.contains('is-nav-open')) {
      if (t.closest && t.closest('#siteNavLinks a[href]')) { ndwSetNav(false); return; }
      if (!nav.contains(t)) ndwSetNav(false);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') ndwSetNav(false); });
  window.matchMedia('(min-width: 981px)').addEventListener('change', function (e) { if (e.matches) ndwSetNav(false); });

  function initHeader() {
    var nav = getNav();
    var SHOP_ALL_URL = (nav && nav.dataset.shopAllUrl) || '';
    var chevron = (nav && nav.dataset.chevron) || '';
    var chevronActive = (nav && nav.dataset.chevronActive) || '';

    /* ---- Shop mega-menu: hover + click/tap, Esc, outside-click ---- */
    var item = document.querySelector('.site-nav__item--has-menu');
    var toggle = document.querySelector('.site-nav__link--toggle');
    var menu = document.getElementById('shopMenu');
    if (item && toggle && menu) {
      var CLOSE_DELAY = 150, closeTimer = null;
      function openMenu() {
        window.clearTimeout(closeTimer);
        menu.classList.add('is-open');
        if (nav) nav.classList.add('is-menu-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
      function closeMenu() {
        window.clearTimeout(closeTimer);
        menu.classList.remove('is-open');
        if (nav) nav.classList.remove('is-menu-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
      function scheduleClose() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(closeMenu, CLOSE_DELAY);
      }
      item.addEventListener('mouseenter', openMenu);
      item.addEventListener('mouseleave', scheduleClose);
      toggle.addEventListener('click', function (e) {
        /* Desktop (hover-capable nav): click goes to Shop All. Below 981px keep toggle behaviour. */
        if (window.matchMedia('(min-width: 981px)').matches && SHOP_ALL_URL) {
          window.location.href = SHOP_ALL_URL;
          return;
        }
        e.preventDefault();
        if (menu.classList.contains('is-open')) closeMenu(); else openMenu();
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeMenu();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('is-open')) { closeMenu(); toggle.focus(); }
      });
      document.addEventListener('click', function (e) {
        if (!menu.classList.contains('is-open')) return;
        if (!item.contains(e.target)) closeMenu();
      });
      var cats = Array.prototype.slice.call(menu.querySelectorAll('.mega-menu__cat'));
      var cardsets = Array.prototype.slice.call(menu.querySelectorAll('.mega-menu__cardset'));
      cats.forEach(function (cat) {
        function activate() {
          var idx = cat.getAttribute('data-cat-index');
          cats.forEach(function (c) {
            var isActive = c === cat;
            c.classList.toggle('mega-menu__cat--active', isActive);
            var arrow = c.querySelector('.mega-menu__cat-arrow');
            if (arrow) arrow.src = isActive ? chevronActive : chevron;
          });
          cardsets.forEach(function (set) {
            set.hidden = set.getAttribute('data-cat-index') !== idx;
          });
        }
        cat.addEventListener('mouseenter', activate);
        cat.addEventListener('click', function () {
          var h = cat.getAttribute('data-cat-handle');
          if (h && SHOP_ALL_URL) {
            window.location.href = SHOP_ALL_URL.split('#')[0] + '#ndw-cat-' + h;
          } else {
            activate();
          }
        });
      });
    }

    /* ---- Scrolled state: overlay home goes solid; all pages get a shadow ---- */
    if (nav && !nav.hasAttribute('data-nav-solid-locked')) {
      var sync = function () { nav.classList.toggle('is-scrolled', window.scrollY > 8); };
      sync();
      window.addEventListener('scroll', sync, { passive: true });
    }

    /* ---- Mobile accordions: one open at a time ---- */
    var accs = Array.prototype.slice.call(document.querySelectorAll('.site-nav__mobile .m-acc'));
    accs.forEach(function (acc) {
      var t = acc.querySelector('.m-acc__toggle');
      if (!t) return;
      t.addEventListener('click', function () {
        var willOpen = !acc.classList.contains('is-open');
        accs.forEach(function (other) {
          other.classList.remove('is-open');
          var ot = other.querySelector('.m-acc__toggle');
          if (ot) ot.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) { acc.classList.add('is-open'); t.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();

/* Cart count badge — keeps the header cart bubble in sync with the live cart. */
(function () {
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', !n);
    });
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count || 0); })
      .catch(function () {});
  }

  // update on any cart mutation
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var p = _fetch.apply(this, arguments);
      try {
        var a0 = arguments[0];
        var url = String((a0 && a0.url) || a0 || '');
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { setTimeout(refreshCount, 60); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }
  ['cart:refresh', 'cart:build'].forEach(function (ev) {
    document.addEventListener(ev, refreshCount);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCount);
  } else {
    refreshCount();
  }
})();
